import MagicBox from './entry';

export default { path: '/home/magicBox', component: MagicBox };
